import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';

/**
 * API endpoints for starting and cancelling an order of a cart or a single product.
 */
@Injectable({
	providedIn: 'root'
})
export class OrderApi extends HttpService {

	/**
	 * Orders the products which are currently in the shopping cart.
	 * The cart items are not cleared when calling this method.
	 * Use [CartApi.Clear] to clear the cart.
	 */
	async orderCart(): Promise<void> {
		// Do not check out immediately, but wait two seconds,
		// to not overstrain the payment controller.
		// When there is already a checkout timer running, cancel it and start
		// a new one.
		if (this.lastOrderTimer) {
			console.log("Order timer canceled");
			window.clearTimeout(this.lastOrderTimer);
		}
		this.lastOrderTimer = window.setTimeout(async () => {
			console.log("Order API: First cancel, then order");
			await this.cancel(false);
			await this.post<void>('order');
			this.orderSent = true;
		}, 2000);
		console.log("Order scheduled");
	}
	private lastOrderTimer = 0;
	private orderSent = false;

	/**
	 * Orders the product with the given ID.
	 * The current shopping cart is ignored and not ordered.
	 */
	async orderProduct(productID: string): Promise<void> {
		return await this.post<void>('order/' + productID);
	}

	/**
	 * Cancels the current order.
	 * Set the parameter "returnCredit" to true, when hardcash and vouchers should be returned.
	 * Otherwise, they stay in the user's credit.
	 * A cashless process will be cancelled independent of the value of this parameter.
	 * This method returns immediately, so the cancelling process may still be running.
	 */
	async cancel(returnCredit: boolean): Promise<void> {
		console.log("Cancel API");
		this.orderSent = false;
		await this.delete<void>(`order?returnCredit=${returnCredit}`);
	}

}
